"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLocalFontFaceCss = buildLocalFontFaceCss;
exports.getLocalFontFamiliesFromSettings = getLocalFontFamiliesFromSettings;
exports.isLocalFontFamily = isLocalFontFamily;
const customization_1 = require("../api-types/customization");
function escapeCssDoubleQuotedString(value) {
    return value
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"')
        .replace(/\n/g, '\\A ')
        .replace(/\r/g, '\\D ')
        .replace(/\f/g, '\\C ');
}
function buildLocalFontFaceCss(families) {
    var _a;
    const rules = [];
    for (const family of families) {
        if (!((_a = family === null || family === void 0 ? void 0 : family.files) === null || _a === void 0 ? void 0 : _a.length)) {
            continue;
        }
        for (const file of family.files) {
            if (file.type !== 'LOCAL' || !file.src) {
                continue;
            }
            const familyName = escapeCssDoubleQuotedString(family.name);
            const src = escapeCssDoubleQuotedString(file.src);
            rules.push(`
@font-face {
  font-family: "${familyName}";
  src: url("${src}") format("woff2");
  font-weight: ${file.weight};
  font-style: ${file.style};
  font-display: swap;
}`.trim());
        }
    }
    return rules.join('\n');
}
function getLocalFontFamiliesFromSettings(settings) {
    return (0, customization_1.getActiveFontFamilies)(settings).filter((family) => family.files.some((file) => file.type === 'LOCAL'));
}
function isLocalFontFamily(family) {
    var _a;
    return Boolean((_a = family === null || family === void 0 ? void 0 : family.files) === null || _a === void 0 ? void 0 : _a.some((file) => file.type === 'LOCAL'));
}
